import styled from 'styled-components';
import {StyledProps} from './typings';
import breakpoint from '../../../theme/constants/breakpoints';

const gridGap = '1.25rem';

const StyledMasonryLayout = styled.section<StyledProps>`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.$columns.xs}, minmax(0, 1fr))`};
  justify-content: stretch;
  grid-gap: ${gridGap};
  padding: 5px;
  grid-template-rows: ${(props) => (props.$masonrySupported ? 'masonry' : 'auto')};
  margin-bottom: 20px;

  & > div,
  & > a {
    width: initial;
    height: fit-content;
  }

  @media only screen and ${breakpoint.device.s} {
    grid-template-columns: ${(props) => `repeat(${props.$columns.s}, minmax(0, 1fr))`};
  }

  @media only screen and ${breakpoint.device.m} {
    grid-template-columns: ${(props) => `repeat(${props.$columns.m}, minmax(0, 1fr))`};
  }

  @media only screen and ${breakpoint.device.l} {
    grid-template-columns: ${(props) => `repeat(${props.$columns.l}, minmax(0, 1fr))`};
  }
`;

export default StyledMasonryLayout;
